import { render, staticRenderFns } from "./drawPresDetail.vue?vue&type=template&id=683a1afa&scoped=true&"
import script from "./drawPresDetail.vue?vue&type=script&lang=js&"
export * from "./drawPresDetail.vue?vue&type=script&lang=js&"
import style0 from "./drawPresDetail.vue?vue&type=style&index=0&id=683a1afa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683a1afa",
  null
  
)

export default component.exports